module.exports = __webpack_public_path__ + "static/img/reward_effect_pre1.a8bdb969.png";